exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security-list{display:block}social-security-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}social-security-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/features/socialSecurity/socialSecurityList/socialSecurityList.scss
// module id = 2338
// module chunks = 0